import { Container, Header, KeyValuePairs, StatusIndicator } from '@amzn/awsui-components-react';
import React from 'react';
import { NotificationSummary } from 'src/models/dashboard/NotificationSummary';
import { TPELoadingSpinner } from '../shared/TPELoadingSpinner';

export default function NotificationSummaryView(props: { notificationSummaryResult: NotificationSummary, notificationSummaryLoading: boolean }) {
  const { notificationSummaryResult, notificationSummaryLoading } = props;
  // Summary and Completion are stacked vertically so they form the left column beside the
  // MEC calendar card on the dashboard. The column fills the full height of the Grid row so
  // it extends down to match the calendar card (the Completion card grows to fill the gap).
  return <div className="dashboardSummaryColumn">
      <Container
        data-class="summaryContainer"
        header={
          <Header description="Relevant to me">
            Summary
          </Header>
        }
      >
        <TPELoadingSpinner loading={notificationSummaryLoading}>
          <KeyValuePairs
            columns={2}
            items={[
              { label: "Total items", value: <div className="displayLargeBold">{notificationSummaryResult?.totalItems}</div> },
              { label: "Open items", value: <div className="displayLargeBold">{notificationSummaryResult?.openItems}</div> },
              { label: "Overdue", value: <StatusIndicator data-class="dashboardSummaryStatusIndicator" type="warning" colorOverride="red"><span className="displayLargeBold">{notificationSummaryResult?.overdueItems}</span></StatusIndicator> },
              { label: "Due soon", value: <StatusIndicator data-class="dashboardSummaryStatusIndicator" type="warning"><span className="displayLargeBold">{notificationSummaryResult?.dueSoonItems}</span></StatusIndicator> }
            ]}
          />
        </TPELoadingSpinner>
      </Container>
      <Container
        data-class="summaryContainer"
        header={
            <Header>Completion</Header>
        }
      >
        <TPELoadingSpinner loading={notificationSummaryLoading}>
          <div className="completionDiv">
            <span className="displayLargeBold">{notificationSummaryResult?.percentageCompletion}%</span>
            <div>of total items have been completed</div>
          </div>
        </TPELoadingSpinner>
    </Container>
  </div>
}